package com.sddamico

import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.silk.init.InitSilk
import com.varabyte.kobweb.silk.init.InitSilkContext
import com.varabyte.kobweb.silk.theme.colors.palette.background
import com.varabyte.kobweb.silk.theme.colors.palette.color

object SitePalette {
    val background = Color.rgb(0x0F1216)
    val surface = Color.rgb(0x1A1F25)
    val surfaceHover = Color.rgb(0x222930)
    val border = Color.rgb(0x2A3038)
    val primary = Color.rgb(0x4A7C59)
    val primaryHover = Color.rgb(0x5A9469)
    val accent = Color.rgb(0xC9A84C)
    val accentMuted = Color.rgb(0x8A7535)
    val text = Color.rgb(0xE8E6E1)
    val textSecondary = Color.rgb(0x9A9690)
    val textMuted = Color.rgb(0x6A6660)
    val error = Color.rgb(0xC45C5C)
    val statusActive = Color.rgb(0x4A8A7A)
    val statusFinal = Color.rgb(0x6A6A6A)
}

@InitSilk
fun initTheme(ctx: InitSilkContext) {
    ctx.theme.palettes.dark.background = SitePalette.background
    ctx.theme.palettes.dark.color = SitePalette.text
    ctx.theme.palettes.light.background = SitePalette.background
    ctx.theme.palettes.light.color = SitePalette.text
}
